import React, { useRef, useEffect } from 'react';
import { useSelector } from '../store';
import { selectCall } from '../store/reducers/janus';

export default function Audio() {
  const audioRef = useRef<HTMLAudioElement>(null)
  const call = useSelector(selectCall)

  useEffect(() => {
    if (!audioRef.current) { return }
    try {
      audioRef.current.srcObject = call.remoteStream ?? null
    } catch (err) {
      console.error('failed to set srcObject for call', call.remoteStream, err)
    }
  }, [call.remoteStream])

  return <audio id='remoteAudio' autoPlay loop ref={audioRef} />
}
